<template>
  <div class="map">
    <div
      id="gmap"
      :class="{
        map_limited: showOrderMapWindow,
      }"
    ></div>

    <div
      v-if="showOrderMapWindow && order != null"
      class="map-order"
      :class="{
        'map-order_show': showAnimation,
      }"
    >
      >
      <orders-modal />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { globalConfig } from '@/config'
import store from '@/store/index'
import GoogleMapsLoader from 'google-maps'
import rich from 'googlemaps-js-rich-marker'
import moment from 'moment'
import ordersModal from '@/components/modals/orders/ordersModal'

GoogleMapsLoader.KEY = globalConfig.googleMapsKey
GoogleMapsLoader.LANGUAGE = globalConfig.lang
const SnazzyInfoWindow = require('snazzy-info-window')

export default {
    props: ['editOpen', 'deleteOpen', 'typeMap', 'updated'],
    data() {
        return {
            isGrabbed: false,
            mapData: [],
            markersArray: [],
            infoWindowsArray: [],
            map: '',
            lists: [],
            interval: '',
            optionsMap: {
                center: {
                    // austria / germany center
                    lat: this.$config.behavior === 'hilfy' ? 48.219308 : 51.234072, // austria latitude, germany latitude
                    lng: this.$config.behavior === 'hilfy' ? 16.393125 : 6.80885, // austria longtitude, germany longtitude
                },
                // 50.450735, 30.527831
                zoom: 11,
                disableDefaultUI: true,
                clickableIcons: false,
                maxZoom: 18,
                test: this.$config,
            },
            counter: 0,
            colors: ['#EC4521', '#B6B2B1', '#013EFD', '#FDCF01', '#EE01FD'],
            usedColors: [],
            showAnimation: false,
            orderModalState: {
                now: null,
                past: null,
            },
        }
    },
    components: { ordersModal },
    computed: {
        ...mapGetters({
            mapUpdateGetters: 'mapUpdateGetters',
            mapMasterGetters: 'mapMasterGetters',
            mapViewGetters: 'mapViewGetters',
            mapServiceGetters: 'mapServiceGetters',
            mapMasterId: 'mapIdGetters',
            showOrderMapWindow: 'showOrderMapWindowGetters',
            order: 'orders/orderGetters',
            mapDateGetters: 'mapDateGetters',
        }),
        type() {
            switch (this.typeMap) {
            case 'engineers':
                return 'employee'
            case 'masters':
                return 'employee'
            case 'clients':
                return 'clients'
            case 'companies':
                return 'clients'
            default:
                return 'employee'
            }
        },
    },
    watch: {
        updated() {
            this.usedColors = []
        },
        mapMasterGetters() {
            this.usedColors = []

            this.setOrderMapWindow(false)
            this.initMasterMap()
        },
        mapViewGetters(v) {
            this.usedColors = []

            this.checkView(v)
            if (v === 'all') {
                this.setOrderMapWindow(false)
            }
        },
        mapServiceGetters() {
            this.usedColors = []

            this.setOrderMapWindow(false)
            this.checkView(this.mapViewGetters)
        },
        showOrderMapWindow(v) {
            if (v) {
                setTimeout(() => {
                    this.showAnimation = true
                }, 400)
            } else {
                this.showAnimation = false
            }
        },
    },
    methods: {
        ...mapMutations({
            setOrderMapWindow: 'setOrderMapWindow',
            setState: 'sip/setState',
            setMapService: 'setMapService',
            setToggleModalState: 'orders/setToggleModalState',
        }),
        ...mapActions({
            fetchById: 'orders/fetchById',
            currentMaster: 'currentMaster',
        }),
        // GOOGLE MAP EVENTS START
        startOfGrabbing() {
            this.isGrabbed = true
        },
        endOfGrabbing() {
            this.isGrabbed = false
        },
        // GOOGLE MAP EVENTS END

        // PAGE NAVIGATION METHODS START
        showCalendar(id) {
            this.$router.push({ name: 'calendar', params: { employee_id: id } })
        },
        // PAGE NAVIGATION METHODS END

        // INFO MODAL METHODS START
        generateInfoModal(data) {
            return `
						<div class="user">

							<div class="user__wrapper">
								<div class="user__img" style="background-image: url(${
    data.master.small_image
})"></div>
								<div class="user__info">
									<div class="user__info-name">${data.master.first_name} ${
    data.master.last_name
}</div>
 									<div class="user__info-phone">${data.master.phone}</div>
									<div class="user__info-email user__info-email--user">${data.master.email}</div>

									<div class="user__info-status user__info-status--user">${
    data.master.current_status
        ? this.$t(`status.${data.master.current_status}`)
        : ''
}</div>

									<div class="user__info-buttons">
										<div class="user__info-button">
											<div class="js-show-calendar" data-id="${data.master.id}">
												<svg class="icon">
													<use xlink:href="/images/svg/symbols.svg#svg-user-calendar"></use>
												</svg>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>`
        },
        addInfoWindow(marker, data) {
            const info = new SnazzyInfoWindow({
                marker,
                maxWidth: 200,
                content: this.generateInfoModal(data, this.type),
                placement: 'bottom',
                offset: {
                    top: '-150px',
                    left: '-150px',
                },
                closeWhenOthersOpen: true,
                showCloseButton: false,
                callbacks: {
                    open: () => {
                        this.addInfoModalListeners()
                    },
                },
            })
            this.infoWindowsArray.push(info)
        },
        addInfoModalListeners() {
            const calendarBtn = document.querySelector('.js-show-calendar')

            calendarBtn.addEventListener('click', () => {
                const { id } = calendarBtn.dataset
                this.showCalendar(id)
            })
        },
        // INFO MODAL METHODS END

        // MARKER METHODS START
        addMarker(map, position, data) {
            const marker = new rich.RichMarker({
                map,
                position,
                draggable: false,
                flat: true,
                anchor: rich.RichMarkerPosition.MIDDLE,
                content: `<div class="icon-marker"
								style="
									background-image: url(${data.master.small_image});
									${
    data.is_active_time_shift === true
        ? 'border: 2.5px solid #32CD32'
        : 'border: 2.5px solid grey'
}
									"
							></div>`,
            })
            this.markersArray.push(marker)
            this.addInfoWindow(marker, data)
        },
        initMarker(element, map, markersBounds) {
            const localMarket = element
            if (localMarket === undefined) {
                return
            }
            store
                .dispatch('specialists/getSpecialist', {
                    id: localMarket.master.master_id,
                    type: this.typeMap,
                })
                .then((res) => {
                    if (!this.checkService(res.data.service.id)) {
                        return
                    }

                    const markerPosition = new window.google.maps.LatLng(
                        +localMarket.latitude,
                        +localMarket.longitude,
                    )
                    markersBounds.extend(markerPosition)
                    localMarket.master = res.data

                    this.addMarker(map, markerPosition, localMarket)
                })
        },
        // MARKER METHODS END

        // POLYLINES METHODS START
        drawPolylines(routes) {
            const flightPlanCoordinates = routes.reduce((accum, item) => {
                const data = {
                    lat: item.latitude,
                    lng: item.longitude,
                }
                accum.push(data)
                return accum
            }, [])

            const flightPath = new window.google.maps.Polyline({
                path: flightPlanCoordinates,
                geodesic: true,
                strokeColor: this.generatePolylineColor(this.colors[0]),
                strokeOpacity: 1.0,
                strokeWeight: 2,
            })
            flightPath.setMap(this.map)

            this.markersArray.push(flightPath)

            return flightPlanCoordinates[0]
        },
        drawPolylinesMarker({ lastPoint, request }) {
            return new rich.RichMarker({
                map: this.map,
                position: new window.google.maps.LatLng(lastPoint.lat, lastPoint.lng),
                draggable: false,
                flat: true,
                anchor: rich.RichMarkerPosition.MIDDLE,
                content: `<img data-id="${request}" style="width: 25px; height: 25px; display: block;" src="https://pf-emoji-service--cdn.us-east-1.prod.public.atl-paas.net/atlassian/flag_on_64.png">`,
            })
        },
        generatePolylineColor() {
            let res
            for (let i = 0; i <= this.colors.length; i++) {
                if (this.usedColors.lastIndexOf(this.colors[i]) === -1) {
                    this.usedColors.push(this.colors[i])
                    res = this.colors[i]
                    break
                }
            }
            return res
        },
        // POLYLINES METHODS END

        // MAP METHODS START
        getData() {
            this.$Progress.start()
            return new Promise((resolve) => {
                store.dispatch('getMapData', this.typeMap).then((res) => {
                    this.mapData = res
                    resolve(this.mapData)
                    this.$Progress.finish()
                })
            })
        },
        updateData() {
            this.clearOverlays().then(() => {
                this.getData().then((res) => {
                    this.setMap(this.map, res)
                })
            })
        },
        clearOverlays() {
            return new Promise((resolve) => {
                if (this.markersArray.length > 0) {
                    this.markersArray.forEach((element) => {
                        element.setMap(null)
                        this.markersArray = []
                    })
                }

                if (this.infoWindowsArray.length > 0) {
                    this.infoWindowsArray.forEach((info) => {
                        info.setMap(null)
                        info.destroy()
                    })
                    this.infoWindowsArray = []
                }

                resolve()
            })
        },
        setMap(map, mapData) {
            const markersBounds = new window.google.maps.LatLngBounds()

            mapData.forEach((element) => {
                this.initMarker(element, map, markersBounds)
            })
        },
        initMasterMap() {
            this.clearOverlays().then(() => {
                const firstDate = moment(
                    this.mapDateGetters === null ? moment() : moment(this.mapDateGetters),
                ).toDate()
                firstDate.setHours(0)
                firstDate.setMinutes(0)
                firstDate.setSeconds(0)

                const date = moment().toDate()
                date.setHours(0)
                date.setMinutes(0)
                date.setSeconds(0)

                if (firstDate.toString() === date.toString()) {
                    this.currentMaster({ type: this.typeMap, id: this.mapMasterId }).then(
                        (item) => {
                            const markersBounds = new window.google.maps.LatLngBounds()
                            this.initMarker(item, this.map, markersBounds)
                        },
                    )
                }

                if (this.mapMasterGetters.length === 0) {
                    return
                }

                this.usedColors = []
                this.mapMasterGetters.forEach(async (item) => {
                    if (item.route.length === 0) {
                        return
                    }

                    if (this.mapServiceGetters !== 'all') {
                        if (!this.checkService(item.service_id)) {
                            return
                        }
                    }

                    const lastPoint = this.drawPolylines(item.route)
                    const marker = this.drawPolylinesMarker({
                        lastPoint,
                        request: item.request_id,
                    })

                    await this.fetchById(item.request_id)

                    this.markersArray.push(marker)

                    marker.addListener('click', async ({ target }) => {
                        const request_id = target.getAttribute('data-id')

                        if (this.orderModalState.now === request_id) {
                            this.setOrderMapWindow(false)
                            this.orderModalState.now = null
                        } else {
                            this.orderModalState.now = request_id
                            await this.fetchById(request_id)
                            this.setOrderMapWindow(true)
                            this.setToggleModalState(true)
                        }
                    })
                })

                this.map.addListener('click', () => {
                    this.setOrderMapWindow(false)
                })
            })
        },
        setMapInterval() {
            this.interval = setInterval(() => {
                if (this.isGrabbed) {
                    return
                }

                if (this.mapViewGetters === 'all') {
                    this.updateData()
                } else {
                    this.initMasterMap()
                }
            }, 5000)
        },
        clearMapInterval() {
            clearInterval(this.interval)
        },
        // MAP METHODS END

        // INIT METHOD HELPERS START
        prepareData() {
            this.getData().then((res) => {
                if (res === undefined) {
                    return
                }

                this.setMap(this.map, res)
            })
        },
        initMapEvents() {
            this.map.addListener('dragstart', () => {
                this.isGrabbed = true
            })
            this.map.addListener('dragend', () => {
                this.isGrabbed = false
            })
        },
        // removeMapEvents() {},
        initMap() {
            this.map = new window.google.maps.Map(
                document.getElementById('gmap'),
                this.optionsMap,
            )
        },
        // INIT METHOD HELPERS END

        // INIT METHOD START
        init() {
            this.initMap()
            this.initMapEvents()
            this.prepareData()
        },
        // INIT METHOD END

        // HELPERS START
        checkService(v) {
            return v === this.mapServiceGetters || this.mapServiceGetters === 'all'
        },
        checkView(v) {
            if (v === 'all') {
                this.updateData()
            } else {
                this.initMasterMap()
            }
        },
    // HELPERS END
    },
    mounted() {
        this.init()
        this.setMapInterval()
    },
    beforeDestroy() {
        this.clearMapInterval()
        this.setMapService('all')
    },
}
</script>

<style lang="scss">
@import "src/assets/sass/main";

.map {
  border-radius: 8px;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}

#gmap {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  transition: all 0.4s ease;
  width: 100%;
}

.user {
  display: inline-block;
  padding: 24px;
  width: 405px;
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.16);
  box-sizing: border-box;

  &__wrapper {
    display: flex;
  }
  &__img {
    margin-right: 24px;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: solid 1px $secondColor;
    background-image: url("/images/content/small.jpg");
    background-size: cover;
    background-position: center;
  }
  &__info {
    color: #4d4d4d;
    font-size: 16px;
    max-width: 240px;
    &-name {
      font-family: $fontBold;
      margin-bottom: 24px;
      margin-top: 9px;
    }
    &-post {
      margin-bottom: 24px;
    }
    &-phone {
      margin-bottom: 9px;
    }
    &-email {
      width: 100%;
      margin-bottom: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &--user {
        margin-bottom: 24px;
      }
    }
    &-address {
      font-size: 12px;
      margin-bottom: 24px;
      font-family: $fontBold;
      &--user {
        display: none;
      }
    }
    &-status {
      font-family: $fontBold;
      margin-bottom: 41px;
      color: #71bd4a;
      &--user {
        margin-bottom: 10px;
      }
    }
    &-show {
      font-size: 12px;
      margin-bottom: 36px;
      text-decoration: underline;
      cursor: pointer;
    }
    &-buttons {
      display: flex;
      align-items: center;
      flex-grow: 3;
    }
    &-button {
      margin-right: 16px;
      cursor: pointer;
      & .icon {
        width: 30px;
        height: 30px;
        transition: 0.5s;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
}

.icon-marker {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: solid 1px $secondColor;
  background-image: url("/images/content/small.jpg");
  background-color: $primaryColor;
  background-size: cover;
  background-position: center;
  z-index: 50;
  position: relative;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.4);
}
.si-float-wrapper {
  position: absolute;
}

.map {
  display: flex;
  background-color: rgba(97, 66, 45, 0.05) !important;
  box-shadow: unset !important;
}

.map_limited {
  width: 71% !important;
}

@keyframes fromFullToLimited {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.map-order {
  width: 100%;
  max-width: 25%;
  margin-left: 4%;
  box-sizing: border-box;
  background-color: #fff;
  transition: all 0.4s ease;
  display: none;
  overflow-y: auto;
}

.map-order_show {
  display: block;
}
</style>
